import { useCallback, useEffect, useId } from 'react'

import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { modalActions } from '@/store/modal'

export const useModalProps = () => {
  const dispatch = useReduxDispatch()
  const id = useId()
  const isOpen = useReduxSelector((s) => s.modal.stack.some((modal) => modal.id === id))
  const isFirst = useReduxSelector((s) => s.modal.stack[0]?.id === id)
  const isTop = useReduxSelector((s) => s.modal.stack.at(-1)?.id === id)

  const setIsOpen = useCallback(
    (isOpenChange: boolean) => {
      dispatch(isOpenChange ? modalActions.open({ id }) : modalActions.close(id))
    },
    [dispatch, id],
  )

  useEffect(
    () => () => {
      dispatch(modalActions.close(id))
    },
    [dispatch, id],
  )

  return { isFirst, isOpen, isTop, setIsOpen }
}
